export const shopify = {
  tokenHelp:
    'Der Token ist zu finden unter "Apps and sales channels > Develop Apps"',
  oAuthFlowHelp: "Meinen Verkaufskanal verbinden",
  authSuccess: "Authentifizierung erfolgreich",
  migrationSuccess: "Erolgreich Token aus Shopify übernommen."
};
